import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "stepper"
  }, [_c('span', {
    class: {
      active: _vm.isGray
    },
    on: {
      "click": _vm.reduce
    }
  }, [_vm._v("-")]), _c('input', {
    attrs: {
      "type": "number",
      "min": _vm.minNum,
      "max": _vm.max,
      "maxlength": "6",
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.num
    },
    on: {
      "change": _vm.numchange
    }
  }), _c('span', {
    class: {
      active: _vm.num >= _vm.max
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("+")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };